import { render, staticRenderFns } from "./SchoolClassItems.vue?vue&type=template&id=60400bad"
import script from "./SchoolClassItems.vue?vue&type=script&lang=js"
export * from "./SchoolClassItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports